import React, { useState } from "react";
import "../styles/otp.css";
import { Link } from "react-router-dom";
import backgroundImage from "../assets/login/firstlog.png";
import { useNavigate } from "react-router-dom"; 

const OTP = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const navigate = useNavigate();

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handleLogin = () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length < 4) {
      alert("Please enter the complete OTP.");
      return;
    }

    // Directly navigate after entering OTP (no JSON check)
    alert("OTP Entered!");
    navigate("/signinform"); // change route as needed
  };

  const handleSignUp = () => {
    navigate("/signup"); // direct navigation to signup page
  };

  return (
    <div className="otp-container">
      <div
        className="otp-background"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      ></div>

      <div className="otp-box">
        <h1 className="otp-title">Welcome to Lingayath Weds</h1>
        <p className="otp-subtitle">
          Enter the otp that have sent to ur phonr number
        </p>

        <label className="otp-label">Enter OTP</label>
        <div className="otp-input-group">
          {otp.map((value, index) => (
            <input
              key={index}
              id={`otp-${index}`}
              type="text"
              maxLength="1"
              value={value}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="otp-input"
            />
          ))}
        </div>

        <button className="otp-login-btn" onClick={handleLogin}>
          <Link
            to="/siginform"
            style={{ textDecoration: "none", color: "white" }}
          >
            Login
          </Link>
        </button>

        <div className="otp-divider"></div>

        
      </div>
    </div>
  );
};

export default OTP;
